<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-the-rise-of-the-d.a.w.n.">
<h1></h1>
<h1 style="font-family:Ariel">Part 1: The Rise of <br/>the D.A.W.N.</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?f641f32c